


























































































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { institutionServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import BindArea from './bindArea.vue';

@Component({
  components: { CollapseTransition, TreeUnit, BindArea },
  mixins: [TableStripe],
})
export default class InstitutionIndex extends Vue {
  openTreeFlag = false; // 是否打开树节点
  treeData: Array<any> = []; // 树状图数据
  // 树形图的数组
  defaultProps: object = {
    children: 'children',
    label: 'name',
  };
  openAsideFlag = true; // 侧边栏是否打开
  // 搜索表单数据
  formData: object = {
    name: undefined, // 机构名称
  };
  formShow = false; // 是否显示表单搜索
  // table项循环数据
  tableOptions: any[] = [
    { label: '机构名称', prop: 'name' },
    { label: '排序号', prop: 'sort' },
  ];
  // table数据
  tableData: any[] = [];
  get orgList() {
    return this.$store.state.user.orgList;
  }

  orgIdToName(id: any) {
    const a: any = this.orgList.find((s: any) => {
      return s.spaceId === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  showTree(flag: boolean) {
    this.openAsideFlag = flag;
  }

  getNodeIds(data: any) {
    this.getAllData();
  }

  /**
   * @desc Vue 创建数据生命周期
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取所有数据
    this.getAllData();
    // 初始化树状图数据
    this.getTreeData();
  }

  // dom 挂载完成阶段
  mounted(): void {
    // 打开数据树所有一级目录
    this.treeData.forEach(item => {
      (this.$refs.treeRef as any).getNode(item.id).expanded = true;
    });
  }

  /**
   * @desc 获取树状图数据
   * @param1 暂无
   * @returns 暂无
   */
  getTreeData() {
    // 树形图数组
    institutionServer
      .getAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          this.treeData = arrayToTree(res.data);
        }
      })
      .catch(() => {
        this.$message.error('初始化刷状图失败,请稍后重试!');
      });
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllData() {
    // 获取所有数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = arrayToTree(res.data);
        } else {
          this.$message.error('获取数据失败,请重试!');
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败,请重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性：判断用户状态从而给出状态按钮背景颜色。
   * @param1 传入用户的 state 状态值
   * @returns 返回一个函数，用于传递参数和判断状态按钮背景颜色。
   */
  get setStateColor(): object {
    return (state: boolean): string => {
      if (state) {
        return 'tag-green';
      } else {
        return 'tag-red';
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 状态的计算属性，如果状态是 1 则是正常 ,2 停用, 3 冻结
   * @param1 传入用户的 state 状态值
   * @returns 计算属性返回一个函数可以来传参，函数进行判断。
   */
  get setUserState(): object {
    return (state: boolean): string => {
      if (state) {
        return '正常';
      } else {
        return '停用';
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击箭头打开或关闭所有状态树。
   * @param1 暂无
   * @returns 暂无
   */
  changeTreeState() {
    this.openTreeFlag = !this.openTreeFlag; // 树节点状态取反图标取反
    (this.$refs.treeRef as any).store._getAllNodes().forEach((val: any, i: number) => {
      if (this.openTreeFlag) {
        val.expanded = true;
      } else {
        val.expanded = false;
      }
    });
  }

  /**
   * @desc 点击刷新图标，刷新状态树数据。
   * @param1 暂无
   * @returns 暂无
   */
  refresh() {
    this.getTreeData(); // 刷新树状图数据
    this.resetForm();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 每次点击树节点都会触发的事件，获得当前点击的id
   * @param1 data: 被点击的节点数据对象
   * @returns 暂无
   */
  handleNodeClick(data: any) {
    // 取消被选中的 树节点。
    (this.$refs.treeRef as any).store._getAllNodes().forEach((item: any, i: number) => {
      if (item.data !== data) {
        (this.$refs.treeRef as any).getNode(item.data.id).isCurrent = false;
      }
    });
    (this.formData as any).name = data.name;
    this.search(); // 发起搜索
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 打开和关闭侧边栏
   * @param1 暂无
   * @returns 暂无
   */
  toggleOpen() {
    this.openAsideFlag = !this.openAsideFlag;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    // 获取到符合搜索条件的数据
    institutionServer
      .getAllData({ ...this.formData })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = arrayToTree(res.data);
          this.$message.success('查询成功');
        }
      })
      .catch(() => {
        this.$message.error('查询失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    // 获取全部数据
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏和显示按钮触发，控制表单搜索内容是否显示
   * @param1 暂无
   * @returns 暂无
   */
  setFormShow() {
    this.formShow = !this.formShow;
  }

  /**
   * @desc 点击编辑机构触发，跳转到编辑机构页面
   * @param1 row：该行数据
   * @returns 暂无
   */
  editOrgan(rowId: string) {
    this.$emit('getRow', rowId); // 将 row 传递给编辑机构页面
    this.$emit('update:show', false); // 跳到编辑机构页面
    this.$emit('update:editOrganFlag', 1); // 跳转到编辑机构页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 新增下级机构
   * @param1 row：上级机构数据
   * @returns 暂无
   */
  addNextOrgan(rowId: string) {
    this.$emit('getRow', rowId); // 将 row 传递给编辑机构页面
    this.$emit('update:show', false); // 跳到新增机构页面
    this.$emit('update:editOrganFlag', 2); // 跳转到新增下级页面
  }

  /**
   * @desc 点击新增按钮，跳转到新增机构页面
   * @param1 暂无
   * @returns 暂无
   */
  addOrgan() {
    this.$emit('getRow', ''); // 传递空字符串给新增机构页面
    this.$emit('update:show', false); // 跳到新增机构页面
    this.$emit('update:editOrganFlag', 3); // 跳转到新增页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击展开或折叠按钮触发，展开或折叠 table 树状图
   * @param1 暂无
   * @returns 暂无
   */
  toggleTableTree(flag: boolean) {
    // 展开或折叠所有 table 内容
    this.forArr(this.tableData, flag);
  }

  /**
   * @desc 递归函数，展开全部 table 内容
   * @param1 data：需要循环的数据
   * @param2 flag：判断展开还是折叠
   * @returns 暂无
   */
  forArr(data: any[], flag: boolean) {
    data.forEach(item => {
      (this.$refs.tableRef as any).toggleRowExpansion(item, flag);
      if (item.children) {
        this.forArr(item.children, flag);
      }
    });
  }

  /**
   * @desc 点击停用机构按钮触发，停用该机构
   * @param1 id：该行数据的 id
   * @returns 暂无
   */
  stopOrgan(row: any) {
    this.$confirm(`确认要${row.enabled ? '停用' : '启用'}该机构吗？`, '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        institutionServer
          .editData({ id: row.id, enabled: !row.enabled })
          .then((res: any) => {
            if (res.code === '200') {
              this.getAllData(); // 刷新获取所有数据
              this.$message.success(`${row.enabled ? '停用' : '启用'}成功!`);
            } else {
              this.$message.error(`${row.enabled ? '停用' : '启用'}失败,请稍后重试!`);
            }
          })
          .catch((error: any) => {
            this.$message.error(`${row.enabled ? '停用' : '启用'}失败,请稍后重试!`);
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: `已取消${row.enabled ? '停用' : '启用'}`,
        });
      });
  }

  /**
   * @desc 点击删除机构触发，删除该机构
   * @param1 id：要删除机构的id
   * @returns 暂无
   */
  deleteOrgan(id: string) {
    this.$confirm('确认要删除该机构吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        institutionServer
          .deleteData(id)
          .then((res: any) => {
            if (res.code === '200') {
              this.getAllData(); // 刷新table数据
              this.getTreeData(); // 初始化树状图数据
              this.$message.success('删除成功!');
            }
          })
          .catch(() => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  bindArea(id: string) {
    (this.$refs['BindArea'] as any).showBindAreaDialog(id);
  }

  responseBindHandle() {
    this.getAllData();
  }
}
